// extracted by mini-css-extract-plugin
export default {"container":"_b7Gj","active":"cwnNL","logo":"XfLxI","name":"I20w_","fallbackTitle":"_i5mV"};